import React from "react";
import * as Yup from 'yup';
import { Forms } from "../../common/components/CmForms";
import PeriodInput from "../../common/components/periodInput";
import Period from "../../common/period";
import { BollinoDataDto, PeriodDto } from "../../generated";
const { Form, FormText, ActionBar } = Forms<BollinoDataDto>()

interface Props {
    bollinoVerde: BollinoDataDto;
    onSubmit: (bollinoVerde: BollinoDataDto) => void;
    onCancel: () => void;
}

export default class BollinoVerdeForm extends React.Component<Props> {

    private static validationSchema = Yup.object<Partial<BollinoDataDto>>({
        validity: Yup
            .mixed()
            .test("tipo-intervento-required", "Campo obbligatorio", value => value.from != null && value.to != null),
    })

    render() {
        const { bollinoVerde, onCancel } = this.props;
        return (<Form
            onSubmit={this.props.onSubmit}
            initialValues={bollinoVerde}
            validationSchema={BollinoVerdeForm.validationSchema}
        >
            {({ set, values, errors }) =>
                <>
                    <h3>Bollino {bollinoVerde.codiceBollino}</h3>
                    <div className="row">
                        <div className="col-12">
                            <PeriodInput
                                labelFrom="Valida Da"
                                labelTo="A"
                                period={Period.Create(values.validity.from, values.validity.to)}
                                onChange={period => set("validity", new PeriodDto(period))}
                                error={errors.validity}
                            />
                        </div>
                        <div className="col-12">
                            <FormText
                                name="codiceBollino"
                                label="Codice"
                            />
                        </div>
                    </div>
                    <ActionBar
                        onCancel={onCancel}
                    />
                </>
            }
        </Form>
        );
    }
}
